/* global process */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  setDataset, resetDataset
} from 'store';

import { parseDatasetURL } from 'utilities';

import PredesignedDatasetsDropdownComponent from './Component';

const predesignedDatasets = [
  {
    text: 'Abalone',
    label: 'Abalone',
    value: 'abalone.csv'
  },
  {
    text: 'Advertising',
    label: 'Advertising',
    value: 'AdvertisingMarketing_TypeofCustomer_Age.csv'
  },
  {
    text: 'Airline Prices',
    label: 'Airline Prices',
    value: 'gasticket.csv'
  },
  {
    text: 'Body Mass Index',
    label: 'Body Mass Index',
    value: 'HealthCare_BMI_SSI.csv'
  },
  {
    text: 'Calcium',
    label: 'Calcium',
    value: 'Sex_Calcium.csv'
  },
  {
    text: 'Casino',
    label: 'Casino',
    value: 'casino.csv'
  },
  {
    text: 'Coin Toss',
    label: 'Coin Toss',
    value: 'Coin_Toss.csv'
  },
  {
    text: 'Dice Roll',
    label: 'Dice Roll',
    value: 'Dice_Roll.csv'
  },
  {
    text: 'Health Care',
    label: 'Health Care',
    value: 'HealthCare_Age_Season.csv'
  },
  {
    text: 'Lost Jobs',
    label: 'Lost Jobs',
    value: 'LostJobToMachine.csv'
  },
  {
    text: 'Older Adult Care',
    label: 'Older Adult Care',
    value: 'OlderAdultCare_CareForRelative.csv'
  },
  {
    text: 'Real Estate Purchases',
    label: 'Real Estate Purchases',
    value: 'ConsumerResearch_Age_RealEstatePurchases.csv'
  },
  {
    text: 'Renewable Energy',
    label: 'Renewable Energy',
    value: 'RenewableEnergy_RelianceOnRenewableEnergy.csv'
  },
  {
    text: 'Ride Driverless',
    label: 'Ride Driverless',
    value: 'Automation_RideDriverless.csv'
  },
  {
    text: 'Surgical Infection',
    label: 'Surgical Infection',
    value: 'Age_SSI.csv'
  },
  {
    text: 'Transportation',
    label: 'Transportation',
    value: 'Transportation_CityMPG_HighwayMPG_Year.csv'
  },
  {
    text: 'Wine Quality',
    label: 'Wine Quality',
    value: 'wine-quality.csv'
  }
];

class PredesignedDatasetsDropdownContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      selectedDataset: ''
    };

    this.reset = () => {
      this.props.resetUploadedFile();
      this.props.resetDataset();
    };

    this.handleChange = value => {
      this.reset();
      this.setState({ selectedDataset: value });
      parseDatasetURL(`${process.env.PUBLIC_URL}/datasets/${value}`, this.props.setDataset);
    };
  }

  componentDidMount () {
    if (this.props.isFileUploaded) {
      // this.reset()
    }
  }

  render () {
    return (
      <PredesignedDatasetsDropdownComponent
        value={this.state.selectedDataset}
        options={predesignedDatasets}
        onChange={this.handleChange}
      />
    );
  }
}

PredesignedDatasetsDropdownContainer.propTypes = {
  setDataset: PropTypes.func.isRequired,
  resetDataset: PropTypes.func.isRequired,
  resetUploadedFile: PropTypes.func.isRequired,
  isFileUploaded: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isFileUploaded: !!state.previewTable.datasetFile
});

const mapDispatchToProps = {
  setDataset, resetDataset
};

export default connect(mapStateToProps, mapDispatchToProps)(
  PredesignedDatasetsDropdownContainer
);
